import styled from "@emotion/styled";
import React from "react";
import { Control, Controller, ControllerRenderProps, FieldValues } from "react-hook-form";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { baseInputCss } from "./Question";
import QuestionWrapper from "./QuestionWrapper";

interface Props {
  name: string;
  defaultValue?: string;
  control: Control;
  autoFocus: boolean;
  disabled: boolean;
}

const StyledSSNInput = styled.input`
  ${baseInputCss}
`;

function QuestionSSNInput(props: Props) {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: ControllerRenderProps<FieldValues, string>
  ) => {
    field.onChange(formatSSN(e.target.value));
  };

  return (
    <QuestionWrapper>
      <Controller
        render={({ field }) => (
          <StyledSSNInput
            placeholder={translate(STRINGS.ENTER_NUMBER_HERE)}
            autoFocus={props.autoFocus}
            aria-label={props.name}
            role="textbox"
            {...field}
            type="text"
            disabled={props.disabled}
            onChange={(e) => handleChange(e, field)}
          />
        )}
        control={props.control}
        name={props.name}
      />
    </QuestionWrapper>
  );
}

function formatSSN(value: string) {
  const ssn = value.replace(/[^\d]/g, "");
  const ssnLength = ssn.length;

  if (ssnLength < 4) {
    return ssn;
  }

  if (ssnLength < 6) {
    return `${ssn.slice(0, 3)}-${ssn.slice(3)}`;
  }

  return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5, 9)}`;
}

export default QuestionSSNInput;
